import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import instance from '../Config/AxiosConfig';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const ApiContext = createContext();

export const useDelete = () => {
    return useContext(ApiContext);
};
// centraliser  des méthodes  pour les  partager entre les  composants sans avoir à les passer  via les props. pour eviter la repetition 

export const ApiProvider = ({ children }) => {
    const [deleteResponse, setDeleteResponse] = useState('');

    const [interests, setInterests] = useState([]);

    const deleteItem = (api, id) => {
        const token = Cookies.get('token');
        instance.delete(`${api}/${id}`, token)
            .then(response => {
                Swal.fire({
                    title: "Deleted!",
                    text: "The item has been deleted.",
                    icon: "success"
                });
                setDeleteResponse(response.data);
            })
            .catch(error => {
                Swal.fire({
                    title: "Error!",
                    text: "Failed to delete the item.",
                    icon: "error"
                });
                console.error('Error deleting item:', error);
            });
    };

    const showConfirmDialog = (api, id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to delete this item!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteItem(api, id);
            }
        });
    };

    //pour getter les centres d'interet 
    useEffect(() => {
        const fetchInterests = async () => {
            const token = Cookies.get('token');
            try {
                const response = await instance.get('/interests/interestsUser', token)
                setInterests(response.data);
            } catch (error) {
                console.error('Error fetching user interests:', error);
            }
        };

        fetchInterests();
    }, []);


    //search,join community
    const [search, setSearch] = useState('')
    const [resultSearch, setResultSearch] = useState([]);


    const [activeTab, setActiveTab] = useState('tab-1');
    const [join, setJoin] = useState('')



    const handleSearch = async (e) => {
        e.preventDefault();

        const token = Cookies.get('token');
        let dat = {
            keyword: search
        }
        setActiveTab('tab-1');
        try {


            const response = await instance.get(`/communities/search/${dat.keyword}`, token);
            setResultSearch(response.data);


            console.log('Search results:', response.data);

        }
        catch (error) {
            console.error('Error during search request:', error);

        }

    };





    const handleJoin = async (id) => {
        const token = Cookies.get('token');

        try {
            const response = await instance.get(`/communities/join/${id}`, token);
            setJoin(response)
            if (response.status === 200) {
                toast.success('Successfully joining the community!', {
                    position: "top-right",
                    autoClose: 500,
                    hideProgressBar: false,

                });

            }

            setResultSearch(prevResults => prevResults.filter(community => community.id !== id));

            console.log('join:', response.data);
        } catch (error) {
            toast.error('Error joining community!', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,

            });
            console.error('Error joining:', error);
        }
    };



    return (
        <ApiContext.Provider value={{ setActiveTab, activeTab, deleteItem, showConfirmDialog, deleteResponse, interests, handleSearch, handleJoin, join, resultSearch, search, setSearch }}>
            {children}
        </ApiContext.Provider>
    );
};
